module.exports = __webpack_public_path__ + "img/tiktok.46652faf.svg";